const initialState = {
    dataFaq: []
}

const faqReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_FAQ':
            return {
                ...state,
                dataFaq: action.payload
            }
        default:
            return state
    }
}

export default faqReducer
